import React from 'react'
import WidgetsArea from "./widgets/WidgetsArea";
import WidgetsAreaLockControlArea from "./widgets/WidgetsAreaLockControlArea";
import Alert from "../../shared/components/alerts/Alert";
import ModalComponent from "./ModalComponent";
import WidgetFormContainer from "../containers/WidgetFormContainer";

const DashboardPage =
    ({
         onEditMode,
         onFullScreenClicked,
         onCreateWidgetClicked,
         hideModal,
         fullscreen,
         loading,
         error,
         alert,
         layout,
         widgetsConfigs,
         onLayoutChange,
         onClick,
         dashboard,
         modalIsOpen,
         loadEntitiesTree,
         entitiesTree,
         widgetToEdit,
     }) => {

        return <div style={{height:'100%'}} className="inherit-height table_page_padding">
            <Alert
                {...alert}
            />
            <ModalComponent
                className="add-widget-modal"
                modalIsOpen={modalIsOpen}
                modalData={
                    <WidgetFormContainer
                        widgetToEdit={widgetToEdit}
                        hideModal={hideModal}
                    />
                }
                hideModal={hideModal}
                isEditWidgetForm={false}
            />
            <WidgetsAreaLockControlArea
                onClick={onClick}
                dashboard={dashboard}
                onEditMode={onEditMode}
                onFullScreenClicked={onFullScreenClicked}
                onCreateWidgetClicked={onCreateWidgetClicked}
                dashboardSelected={{}}
                loadEntitiesTree={loadEntitiesTree}
                entitiesTree={entitiesTree}
            />
            <WidgetsArea
                onEditMode={onEditMode}
                isDashboardFullScreen={fullscreen}
                loading={loading}
                error={error}
                layout={layout}
                widgetsConfigs={widgetsConfigs}
                onLayoutChange={onLayoutChange}
            />
        </div>
    };

export default DashboardPage;

